<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
  
    <div class="card">
      <div class="card-body">
        <CRow>
          <CCol sm="5" lg="12">
             <label class="col-4"> Filter Teacher </label>
             <CRow>              
              <CCol sm="5" lg="4" >
              <b-form-select v-model="teacher" :options="options_teacher"></b-form-select>
              
               <CButton class="col-5 mt-3" variant="outline" color="info" @click="filter()">Search</CButton>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
    </div>


    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @search="handleSearch"
                            :btn_show="true"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            :btn_destroy="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_onlineclass_disc.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import onlineclass from '@/services/onlineclass';
import report from '@/services/report';
import member from '@/services/member';

import newcomer from '@/services/newcomer';
import service from '@/services/service';
import keperluan from '@/services/keperluan';

import alertmodal from '@/views/alert/modal.vue';
import Multiselect from 'vue-multiselect'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, alertmodal,Multiselect },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      
      updateSubmit: false,
      fields: [
          {key: 'fullname', sortable: false, },
          {key: 'email', sortable: false},
          {key: 'gender', sortable: false},
          {key: 'teacher_name', sortable: false},
          {key: 'get_result', sortable: false},
          {key: 'created_at', sortable: false},
          {key: 'action', sortable: false},
        //   {key: 'notes', sortable: false, label: 'aa'},
        //   {key: 'tithing', sortable: false, thStyle: { backgroundColor: '#3eef33'}},
        //   {key: 'member_attendance', sortable: false},
        //   {key: 'visitor_attendance', sortable: false},
        //   {key: 'created_at', sortable: false},
          // {key: 'covenant_date', sortable: false},
          // {key: 'volunteer_date', sortable: false},
      ],
      items: [],
      options_member:[],
      options_service:[],
      options_keperluan: [],
      options_teacher: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      options_icare: [],
      options_month: [
        {text: "January", value: "1"},
        {text: "February", value: "2"},
        {text: "March", value: "3"},
        {text: "April", value: "4"},
        {text: "May", value: "5"},
        {text: "June", value: "6"},
        {text: "July", value: "7"},
        {text: "August", value: "8"},
        {text: "September", value: "9"},
        {text: "October", value: "10"},
        {text: "November", value: "11"},
        {text: "December", value: "12"},
      
      ],
      options_year: [],

      getIcare: [],
      getMonth: [],
      getYear: [],

      icare: '',
      month: '',
      year: ''
    }
   },
    created() {
  },

   mounted (){
     this.loadData()
     this.loadPeriod()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     loadData(p) {


      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        icare: this.icare,
        month: this.month,
        year: this.year,
        teacher: this.teacher
      }
      onlineclass.getResultDisc(params)
      .then(res => {
          //console.log(res.periods)
          let getData = res.data
        //   this.getIcare = res.icares
        //   // this.getPeriodsCovenant = res.periods_covenant
        //   this.getYear = res.available_years

        //       this.options_icare = []
        //       for (let i=0; i <= this.getIcare.length-1; i++){
        //         this.options_icare.push({text: this.getIcare[i].name, value:this.getIcare[i].id})
        //       }
        //   //     this.options_periods_covenant = []
        //   //     for (let i=0; i <= this.getPeriodsCovenant.length-1; i++){
        //   //       this.options_periods_covenant.push({text: this.getPeriodsCovenant[i].monthYear, value:this.getPeriodsCovenant[i].monthYear})
        //   //     }
        //       this.options_year = []
        //       for (let i=0; i <= this.getYear.length-1; i++){
        //         this.options_year.push({text: this.getYear[i], value:this.getYear[i]})
        //       }

          this.items = getData.data

              this.options_teacher = []
              this.options_teacher.push({text: '', value:''})
              for (let i=0; i <= res.teacher.length-1; i++){
                this.options_teacher.push({text: res.teacher[i].firstname + ' ' + res.teacher[i].lastname, value:res.teacher[i].id})
              }



          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      //        console.log("asd")
      // console.log(this.getPeriods)
      // console.log("asd")
      // for (let i=0; i <= getPeriods.length-1; i++){
      //   //alert
      //   this.options_periods.push({text: getPeriods[i].monthYear, value:getPeriods[i].monthYear})
      //   console.log('test');
      // }




    },

    openShow(id){
        this.$router.push({name:'Detail Disc',query: {id:id} }) 
        console.log(' open show detail')
    },

    filter(){
      this.loadData()
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

  }
  
}
</script>

<style>

</style>
